import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SimpleBarScroll from "components/SimpleBar";
import ProductGroupingCreate from "pages/product_grouping/ProductGroupingCreate";
import React from "react";

const ProductGroupEditDialog = ({ open, handleClose, group }) => {
  return (
    <CustomDialog
      forceFullScreen={true}
      open={open}
      handleClose={handleClose}
      heading="Edit product group"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <Box padding={2}>
            <ProductGroupingCreate group_id={group.id} fullGrid={false} />
          </Box>
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  );
};

export default ProductGroupEditDialog;
